import {Constructor} from "../../global/constructor"
import {Hash} from "~/interfaces/hashInterfaces"
import ElementHandler from "~/services/elementHandler"
import { IProcessFlowVariableContainer, IProcessFlowVariable } from '~/interfaces/processFlowInterfaces'
import ProcessFlowVariable from '~/models/processFlows/processFlowVariable'
import TrackedModel from '~/models/tracked/trackedModel'
import {ModelType} from '~/enums/modelType'
import { ObjectHelper } from '~/helpers/objectHelper';

export default function ProcessFlowVariableContainer<TBase extends Constructor<TrackedModel>>(Base: TBase) {
  return class VariableContainer extends Base implements IProcessFlowVariableContainer {
    variables: Hash<IProcessFlowVariable> = {};
    _variablesHandler: ElementHandler<ProcessFlowVariable> = new ElementHandler<ProcessFlowVariable>(this, ProcessFlowVariable, 'variables')
    get variablesHandler(): ElementHandler<ProcessFlowVariable> {
      return this._variablesHandler
    }

    get variablesArray(): IProcessFlowVariable[] {
      return this.sortProperty('variables').filter(v => !v.is_default);
    }

    get defaultVariablesArray(): IProcessFlowVariable[] {
      return ObjectHelper.toArray(this.variables).filter(v => v.is_default);
    }

    get allVariablesArray(): IProcessFlowVariable[] {
      return this.sortProperty('variables');
    }

    get hasVariables(): boolean {
      return this.variablesArray.length > 0;
    }

    get objectModelVariables(): Array<IProcessFlowVariable> {
      return this.variablesArray.filter(v => v.variable_type === ModelType.ObjectModel)
    }

    get formVariables(): Array<IProcessFlowVariable> {
      return this.variablesArray.filter(v => v.variable_type === ModelType.Form)
    }

    get fileVariables(): Array<IProcessFlowVariable> {
      return this.variablesArray.filter(v => v.variable_type === ModelType.File)
    }
  };
}